import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withClientConfig } from '@spotahome/soyuz/client';

import { getRentableUnitPrice } from '@common/utils/paymentsAdapter';

import withFavorites from '../withFavorites';
import {
  getHomecardImageSet,
  getRatingFromReviews,
  getUrlWithMovingDates,
  getLabels
} from '../../utils/homecards';

import Homecard from './Homecard';
import { generateHomeCardLabels } from './generateHomeCardLabels';

const getClassName = (visited, selected, tracking) =>
  classNames(
    'home-card',
    'is-animated',
    {
      'home-card--visited': visited,
      'home-card--selected': selected
    },
    tracking
  );

class HomeCard extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    data: PropTypes.shape({
      adId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      checked: PropTypes.bool,
      isSuperlister: PropTypes.bool,
      isSelect: PropTypes.string,
      city: PropTypes.string,
      id: PropTypes.string,
      mainPhotoUrl: PropTypes.string,
      monthlyPrice: PropTypes.shape({
        type: PropTypes.string,
        minimumPrice: PropTypes.number,
        pricesByMonth: PropTypes.shape({
          [PropTypes.string]: PropTypes.number
        }),
        fixedPrice: PropTypes.number
      }),
      currencyIsoCode: PropTypes.string,
      photoUrls: PropTypes.shape({
        homecardHidpi: PropTypes.string,
        homecard: PropTypes.string
      }),
      reviews: PropTypes.shape({
        ratingAverage: PropTypes.number
      }),
      title: PropTypes.string,
      type: PropTypes.string,
      url: PropTypes.string,
      visited: PropTypes.bool
    }).isRequired,
    disabled: PropTypes.bool,
    handleFavorite: PropTypes.func.isRequired,
    noSecurityDeposit: PropTypes.bool,
    freeCancellationDeadline: PropTypes.shape({
      freeCancellationCurrently: PropTypes.bool,
      freeCancellationDeadline: PropTypes.string
    }),
    isFreeCancellationVariant: PropTypes.bool,
    isFavorite: PropTypes.bool.isRequired,
    moveIn: PropTypes.string,
    moveOut: PropTypes.string,
    flexibleMoveIn: PropTypes.bool,
    flexibleMoveOut: PropTypes.bool,
    onCardMouseEnter: PropTypes.func,
    onCardMouseLeave: PropTypes.func,
    onClick: PropTypes.func,
    overflow: PropTypes.bool,
    selected: PropTypes.bool,
    tracking: PropTypes.string,
    clientConfig: PropTypes.shape({
      featureToggle: PropTypes.shape({
        seasonalPriceRange: PropTypes.bool
      })
    }).isRequired,
    hasLazyLoad: PropTypes.bool
  };

  static defaultProps = {
    disabled: false,
    moveIn: '',
    moveOut: '',
    flexibleMoveIn: false,
    flexibleMoveOut: false,
    onCardMouseEnter: () => {},
    onCardMouseLeave: () => {},
    onClick: () => {},
    overflow: false,
    selected: false,
    tracking: '',
    noSecurityDeposit: false,
    freeCancellationDeadline: {},
    isFreeCancellationVariant: false,
    hasLazyLoad: false
  };

  shouldComponentUpdate(nextProps) {
    return (
      this.props.selected !== nextProps.selected ||
      this.props.isFavorite !== nextProps.isFavorite ||
      this.props.freeCancellationDeadline !== nextProps.freeCancellationDeadline
    );
  }

  getHomecard = isFreeCancellationVariant => {
    const {
      data: ad,
      disabled,
      handleFavorite,
      isFavorite,
      moveIn,
      moveOut,
      flexibleMoveIn,
      flexibleMoveOut,
      onClick,
      overflow,
      selected,
      noSecurityDeposit,
      freeCancellationDeadline
    } = this.props;
    const { photoUrls } = ad;
    const adUrl = getUrlWithMovingDates(ad.url, moveIn, moveOut);
    const { data } = this.props;
    const hasPriceRangeToggle = this.props.clientConfig.featureToggle
      .seasonalPriceRange;

    const price = hasPriceRangeToggle
      ? getRentableUnitPrice(
          data.monthlyPrice.type,
          data.monthlyPrice.minimumPrice,
          data.currencyIsoCode,
          data.monthlyPrice.pricesByMonth,
          data.monthlyPrice.fixedPrice,
          hasPriceRangeToggle,
          { moveIn, moveOut },
          { flexibleMoveIn, flexibleMoveOut }
        )
      : {
          type: data.monthlyPrice.type,
          amount: data.monthlyPrice.minimumPrice,
          currencyCode: data.currencyIsoCode,
          isSeasonalPriceFeatureOn: hasPriceRangeToggle
        };

    return {
      disabled, // TODO: this might be treated in the patternLibrary
      favourite: isFavorite, // TODO: review if necessary
      availableFrom: ad.firstAvailableDate,
      handleFavourite: handleFavorite,
      image: ad.mainPhotoUrl,
      imageSet: photoUrls ? getHomecardImageSet(photoUrls) : '',
      isFavorite,
      link: adUrl,
      onClick,
      onMouseEnter: this.handleMouseEnter, // TODO: this might be treated in the patternLibrary
      onMouseLeave: this.handleMouseLeave, // TODO: this might be treated in the patternLibrary
      overflow,
      price,
      rating: getRatingFromReviews(ad.reviews),
      renderLabels: generateHomeCardLabels(ad),
      selected, // TODO: this might be treated in the patternLibrary
      title: ad.title,
      type: ad.type,
      verified: ad.checked,
      labels: getLabels(
        noSecurityDeposit,
        isFreeCancellationVariant ? freeCancellationDeadline : null
      ),
      hasLazyLoad: this.props.hasLazyLoad,
      isSelect: ad.isSelect
    };
  };
  handleMouseEnter = () => {
    this.props.onCardMouseEnter(this.props.data.id);
  };

  handleMouseLeave = () => {
    this.props.onCardMouseLeave(this.props.data.id);
  };

  render() {
    const {
      data: ad,
      selected,
      tracking,
      freeCancellationDeadline,
      isFreeCancellationVariant
    } = this.props;
    const classes = getClassName(ad.visited, selected, tracking);

    return (
      <div
        className={classes}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {freeCancellationDeadline.freeCancellationCurrently ? (
          <Homecard {...this.getHomecard(isFreeCancellationVariant)} />
        ) : (
          <Homecard {...this.getHomecard()} />
        )}
      </div>
    );
  }
}

export default withClientConfig()(withFavorites()(HomeCard));
